import PageHeader from "./PageHeader";
import { useState, useEffect } from "react";

export default function Resources() {

    function getCurrentDimension(){
        return {
              width: window.innerWidth,
              height: window.innerHeight
        }
    }

    const [screenSize, setScreenSize] = useState(getCurrentDimension());

    useEffect(() => {
        const updateDimension = () => {
          setScreenSize(getCurrentDimension())
        }
        window.addEventListener('resize', updateDimension);
        
        return(() => {
            window.removeEventListener('resize', updateDimension);
        })
      }, [screenSize]);

    return (
        <>
        <PageHeader title="Resources" />

        <div className="container-fluid text-center">
            <rssapp-wall id="l4WSxWMnrN7OWS3Y"></rssapp-wall>
            <iframe width={screenSize.width - 80} title="wall" height="1600" src="https://rss.app/embed/v1/wall/l4WSxWMnrN7OWS3Y" frameborder="0"></iframe>
        </div>
        </>
    );
}